import * as yup from 'yup'
import { IntlShape, defineMessages } from 'react-intl'
import { IRouteDirection } from 'features/Routes/types'
import { GTCompanyV2VerticalInput } from 'gql/types.generated'

const messages = defineMessages({
  required: {
    id: 'routes.new.form.required',
    defaultMessage: 'This field is required'
  },
  encodedShape: {
    id: 'routes.new.form.encodedShape.required',
    defaultMessage: 'Calculating the shape is required'
  },
  max: {
    id: 'routes.new.form.max',
    defaultMessage: 'This field must be at most {max} characters'
  },
  requiredOrigin: {
    id: 'routes.new.form.origin.required',
    defaultMessage: 'The origin is required'
  },
  requiredDestination: {
    id: 'routes.new.form.destination.required',
    defaultMessage: 'The destination is required'
  },
  requiredCompany: {
    id: 'routes.new.form.company.required',
    defaultMessage: 'The company is required'
  },
  requiredLines: {
    id: 'routes.new.form.lines.required',
    defaultMessage: 'You need to select at least one line'
  }
})

const ROUTE_NAME_MAX_LENGTH = 100

export const newRouteSchema = (intl: IntlShape): yup.AnyObjectSchema => {
  return yup.object().shape({
    direction: yup
      .string()
      .oneOf([IRouteDirection.OUTBOUND, IRouteDirection.INBOUND])
      .required(intl.formatMessage(messages.required)),
    vertical: yup.string().required(intl.formatMessage(messages.required)),
    inboundRouteName: yup
      .string()
      .max(ROUTE_NAME_MAX_LENGTH, intl.formatMessage(messages.max, { max: ROUTE_NAME_MAX_LENGTH })),
    outboundRouteName: yup
      .string()
      .max(ROUTE_NAME_MAX_LENGTH, intl.formatMessage(messages.max, { max: ROUTE_NAME_MAX_LENGTH })),
    origin: yup.object().shape({
      name: yup.string()
    }),
    destination: yup.object().shape({
      name: yup.string()
    }),
    company: yup.object().shape({
      id: yup.string().required(intl.formatMessage(messages.requiredCompany))
    }),
    client: yup.object().when('vertical', {
      is: (vertical: string): boolean =>
        vertical === GTCompanyV2VerticalInput.Team || vertical === GTCompanyV2VerticalInput.Rental,
      then: yup.object().shape({
        id: yup.string().required(intl.formatMessage(messages.required))
      })
    }),
    site: yup.object().shape({
      id: yup.string().optional()
    }),
    lines: yup.array().min(1, intl.formatMessage(messages.requiredLines)),
    encodedShape: yup.string().required(intl.formatMessage(messages.encodedShape))
  })
}
